import { render, staticRenderFns } from "./checkEditorBodyComposition.vue?vue&type=template&id=8509e50a&scoped=true&"
import script from "./checkEditorBodyComposition.vue?vue&type=script&lang=js&"
export * from "./checkEditorBodyComposition.vue?vue&type=script&lang=js&"
import style0 from "./checkEditorBodyComposition.vue?vue&type=style&index=0&id=8509e50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8509e50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8509e50a')) {
      api.createRecord('8509e50a', component.options)
    } else {
      api.reload('8509e50a', component.options)
    }
    module.hot.accept("./checkEditorBodyComposition.vue?vue&type=template&id=8509e50a&scoped=true&", function () {
      api.rerender('8509e50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkEditorBodyComposition.vue"
export default component.exports